<div class="nav-item" [ngClass]="{ 'nav-caption': item.navCap }">
  <ng-container *ngIf="item.navCap; else menuItem">
    <div mat-subheader class="nav-caption" (click)="onNavCapClick(item)">
      <span>{{ item.navCap }}</span>
      <i-tabler 
        *ngIf="item.expanded !== undefined" 
        class="routeIcon" 
        [name]="item.expanded ? 'chevron-down' : 'chevron-right'"
        matListItemIcon>
      </i-tabler>
    </div>

    <div
      class="nav-children"
      [@expandCollapse]="item.expanded ? 'expanded' : 'collapsed'"
    >
      <app-nav-item
        *ngFor="let child of item.children"
        [item]="child"
        [depth]="depth + 1"
      ></app-nav-item>
    </div>
  </ng-container>

  <ng-template #menuItem>
    <a
      mat-list-item
      (click)="onItemSelected(item)"
      [ngClass]="{
        'mat-toolbar mat-primary activeMenu': isItemActive(item)
      }"
      class="menu-list-item primary"
    >
      <i-tabler
        class="routeIcon"
        [name]="item.iconName"
        matListItemIcon
      ></i-tabler>
      <span class="hide-menu">{{ item.displayName }}</span>
    </a>
  </ng-template>
</div>